module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker77-api.relevant-digital.com/"}};